import { Spinner } from '../Spinner';
import { ButtonContent, StyledButton } from './Button.styles';
import type { ButtonProps } from './Button.types';

export const Button = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  selected,
  loading = false,
  disabled,
  children,
  ...props
}: ButtonProps) => (
  <StyledButton
    data-variant={variant}
    data-size={size}
    $fullWidth={fullWidth}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    {...(selected !== undefined
      ? { 'aria-pressed': selected, 'data-selected': selected || undefined }
      : {})}
    {...props}
  >
    <ButtonContent>
      {loading && <Spinner aria-hidden />}
      {children}
    </ButtonContent>
  </StyledButton>
);
